const list = {
  en: {
    agent: {
      status: "Status",
      paw: "Paw",
      host: "Host",
      display_name: "Display Name",
      username: "Username",
      privilege: "Privilege",
      last_seen: "Last Seen",
      created_at: "Created",
      architecture: "Architecture",
      platform: "OS",
      pid: "PID",
      ppid: "PPID",
      exe_name: "Executable Name",
      location: "Location",
      executors: "Executors",
      proxy_receivers: "P2P Proxy Receivers",
      proxy_chain: "P2P Chain Receivers",
      agentName: "Agent Name",
      contact: "Contact"
    }
  },
  pt: {
    agent: {
      status: "Estado",
      paw: "Paw",
      host: "Host",
      display_name: "Nome de Exibição",
      username: "Nome de Usuário",
      privilege: "Privilégio",
      last_seen: "Última Visualização",
      created_at: "Criado Em",
      architecture: "Arquitetura",
      platform: "SO",
      pid: "PID",
      ppid: "PPID",
      exe_name: "Nome do Executável",
      location: "Localização",
      executors: "Executores",
      proxy_receivers: "P2P Proxy Receivers",
      proxy_chain: "P2P Chain Receivers",
      agentName: "Nome do Agente",
      contact: "Contato"
    }
  },
  es: {
    agent: {
      status: "Estado",
      paw: "Paw",
      host: "Host",
      display_name: "Mostrar Nombre",
      username: "Nombre de Usuario",
      privilege: "Privilegio",
      last_seen: "Visto por Última Vez",
      created_at: "Creado En",
      architecture: "Arquitectura",
      platform: "SO",
      pid: "PID",
      ppid: "PPID",
      exe_name: "Nombre del Ejecutable",
      location: "Ubicación",
      executors: "Ejecutores",
      proxy_receivers: "P2P Proxy Receivers",
      proxy_chain: "P2P Chain Receivers",
      agentName: "Nombre del Agente",
      contact: "Contacto"
    }
  }
}
export default list
